import {PageHeader} from '@/components/molecules'
import {PageContainer} from '@/components/organisms'
import {StoreList} from '@/containers'

export const StoreListPage = () => {
  return (
    <div>
      <div className="flex flex-row justify-between">
        <PageHeader title={'Store List'} />
      </div>
      <PageContainer data-testid="store-list-page-content">
        <StoreList />
      </PageContainer>
    </div>
  )
}

export default StoreListPage
